import React, { useState } from "react";
import Drawer from 'react-modern-drawer';
import contractServices from "../Contracts/contractServices";
import { CommonUtilities } from "../../commonUtils";
import projectServices from "./projectServices";

export default function ContractSearch(projectDetails: any, onExport: any) {

    const [isOpen, setIsOpen] = React.useState(false);
    const [activeTabUpper, setActiveTabUpper] = useState(0);
    const [activeTabLower, setActiveTabLower] = useState(0);
    const [contractslist, initContractslist] = useState<any[]>([]);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);


    const pID: any = [projectDetails.projectDetails.projectId];

    function handleUpperTabClick(index: any) {
        setActiveTabUpper(index)
    }

    function handleLowerTabClick(index: any) {
        setActiveTabLower(index)
    }

    const getGroupByValue = (activeTabUpper: number) => {
        switch (activeTabUpper) {
            case 0:
                return 'ItemCode';
            case 1:
                return 'RoyaltyFormat';
            case 2:
                return 'TerritoryCode';
            default:
                return 'ItemCode';
        }
    };


    const getContractTypeValue = (activeTabLower: number) => {
        switch (activeTabLower) {
            case 0:
                return 'Indie';
            case 1:
                return 'Sub';
            case 2:
                return 'Main';
            default:
                return 'Indie';
        }
    };


    function handleCheckboxChange(event: any, row: any) {
        const newData = [...selectedRows];

        if (event.target.checked) {
            newData.push(row);
        } else {
            const index = newData.findIndex((item: any) => item.contractRefNum === row.contractRefNum);
            if (index >= 0) {
                newData.splice(index, 1);
            }
        }
        setSelectedRows(newData);
    }



    const handleSearch = () => {


        const selectedContractRefNums = selectedRows.map((row) => row.contractRefNum);

        const data = {
            projectId: projectDetails.projectDetails.projectId,
            type: 'Compare',
            GroupBy: getGroupByValue(activeTabUpper),
            contractRefNum: selectedContractRefNums.join(','),
            contractType: getContractTypeValue(activeTabLower),

        };

        projectServices.financialPerformanceCompare(data)
            .then((response) => {
                console.log('success', response);
                projectDetails.onSearchResults(response, data);
            })
            .catch((error) => {
                console.error('error', error);
                projectDetails.onSearchResults(null, data);
            });
    };


    const handleExport = () => {
        const selectedContractRefNums = selectedRows.map((row) => row.contractRefNum);

        const data = {
            projectId: projectDetails.projectDetails.projectId,
            type: 'Compare',
            GroupBy: getGroupByValue(activeTabUpper),
            contractRefNum: selectedContractRefNums.join(','),
            contractType: getContractTypeValue(activeTabLower),
            export: 1

        };

        projectServices.financialPerformanceCompareExport(data)
            .then((response) => {
                console.log('export done', response);
            });


    };

    const toggleDrawer = () => {
        setIsOpen(!isOpen);
    };
    const Data: any = {
        ProjectId: pID,
    };

    const getContract = () => {
        Data.ProjectId = projectDetails.projectDetails.projectId;

        contractServices.ContractListing(Data)
            .then((res) => {
                CommonUtilities.relativeDataRemapping(res.data, res.headers.original);
                initContractslist(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
            });
    };

    const handleReset = () => {
        setSelectedRows([]);
    };

    return (
        <div>
            <div className="positionAbsolute" style={{ top: '5%', right: '0' }} onClick={() => { setIsOpen(true); getContract() }}>
                <i className="text-xxl icon-circle-left"></i>

            </div>

            <Drawer open={isOpen} onClose={toggleDrawer} direction="right" className="react-drawer" style={{ width: "100%" }}>

                <div className="ws-6 pull-right box" >

                    <div className="box-header  noBorderRadius bg-blue pLarge ">
                        Contract Search
                    </div>

                    <div className="box-content">

                        <ul className="nav nav-tabs ws-12">
                            <li className={`nav-horizontal ${activeTabUpper === 0 ? 'active mr' : 'mr'}`} onClick={() => handleUpperTabClick(0)}>
                                ItemCode
                            </li>

                            <li className={`nav-horizontal ${activeTabUpper === 1 ? 'active mr' : 'mr'}`} onClick={() => handleUpperTabClick(1)}>
                                RoyaltyFormat
                            </li>

                            <li className={`nav-horizontal ${activeTabUpper === 2 ? 'active mr' : 'mr'}`} onClick={() => handleUpperTabClick(2)}>
                                TerritoryCode
                            </li>
                        </ul>

                        <ul className="nav nav-tabs ws-12 mtl">
                            <li className={`nav-horizontal ${activeTabLower === 0 ? 'active mr' : 'mr'}`} onClick={() => handleLowerTabClick(0)}>
                                Indie
                            </li>

                            <li className={`nav-horizontal ${activeTabLower === 1 ? 'active mr' : 'mr'}`} onClick={() => handleLowerTabClick(1)}>
                                Sub
                            </li>

                            <li className={`nav-horizontal ${activeTabLower === 2 ? 'active mr' : 'mr'}`} onClick={() => handleLowerTabClick(2)}>
                                Main
                            </li>
                        </ul>


                        <div className="ws-12">

                            <h5 className="mb pull-left mtxl">
                                Associated Contracts ({contractslist.length})
                            </h5>

                            <div className="allowVscroll ws-12">
                                <table>
                                    <thead>
                                        <tr>
                                            <th><button onClick={handleSearch} >All</button></th>
                                            <th>Contract Title</th>
                                            <th>Contract Ref Num</th>
                                            <th>Contract Account</th>
                                            <th>Contract Type</th>
                                        </tr>

                                    </thead>

                                    <tbody>
                                        {contractslist.map((row, index) => (
                                            <tr key={`${row.contractRefNum}-${index}`}>
                                                <td><input type="checkbox" onChange={(event) => handleCheckboxChange(event, row)} /></td>
                                                <td>{row.contractTitle}</td>
                                                <td>{row.contractRefNum}</td>
                                                <td>{row.contractAccount}</td>
                                                <td>{row.contractType}</td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>

                            </div>

                        </div>

                    </div>


                    <div className="box-footer">

                        <button className="icon-btn edit" onClick={handleSearch}> Search</button>

                        <button className="icon-btn delete" onClick={handleReset}> Reset</button>

                        <button className="icon-btn primary" onClick={handleExport}>
                            <i className="icon-download"></i>
                        </button>

                        <button className="icon-btn delete pull-right" onClick={() => toggleDrawer()}>Close</button>

                    </div>
                    
                </div>
            </Drawer >

        </div >
    )


}